import { Flex, IconTeam, Spacer } from '@zillow/constellation';
import { Heading, Modal, Paragraph, Tag, Text } from '@zillow/constellation-10';

import { StyledFlexContainer } from './StyledComponents';

import ModalFooter from '../../../Modal/ModalFooter';
import { type TagTone } from '../../../../utils/statusTagUtils';

type Props = {
  onClose: () => void;
  onCancel: () => void;
  onSubmit: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inProgressModules: Array<Record<string, any>>;
};

const ReviewSecurityDepositMultiPolicyConfirmationModal = ({
  onClose,
  onCancel,
  onSubmit,
  inProgressModules,
}: Props) => {
  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && onClose()}
      header={<Heading level={3}>Security Deposit</Heading>}
      footer={<ModalFooter onCancel={onCancel} cancelText="Back" submitText="Confirm" onSubmit={onSubmit} />}
      size={{ base: 'fullScreen', md: 'lg' }}
      body={
        <div data-testid="rental-protection-two-step-opt-in-review-security-deposit-multi-policy-confirmation-modal">
          <Spacer paddingX={{ default: 'md', sm_lte: 0 }} paddingY={{ default: 'lg', sm_lte: 0 }}>
            <Heading level={4} fontFamily="heading-alt">
              Multiple policies in progress
            </Heading>
            <Paragraph css={{ marginBottom: '400' }}>
              When you click &apos;Confirm&apos;, we will update the security deposit for the following policies:
            </Paragraph>
            <StyledFlexContainer
              display="flex"
              flexDirection="row"
              alignItems="flex-start"
              gap="xs"
              padding={{ default: 'sm', sm_lte: 0 }}
            >
              <Flex
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                gap="md"
                padding={{ default: 'sm', sm_lte: 0 }}
              >
                {inProgressModules.length > 0 &&
                  inProgressModules.map((item, id: React.Key) => {
                    return (
                      <div key={id}>
                        <Flex display="flex" alignItems="center" gap={{ default: 'xs', sm_lte: 0 }}>
                          <Flex display="flex" flex={{ sm_lte: 2 }}>
                            <Text>{item.selector.description.text}</Text>
                          </Flex>
                          <Flex display="flex" flex={{ sm_lte: 1 }}>
                            <Tag
                              size="sm"
                              tone={item.tagStatus as TagTone}
                              css={{ marginLeft: { base: '0', md: '200' }, marginTop: '100' }}
                            >
                              {item.tagText}
                            </Tag>
                          </Flex>
                        </Flex>
                        {item.selector?.secondaryDescription?.text && (
                          <Flex display="flex" alignItems="center" gap="md">
                            {item.selector.secondaryDescription.text.includes('+ others') && (
                              <IconTeam size="xs" fontColor="textLight" />
                            )}
                            <Text css={{ color: 'gray.400' }}>{item.selector.secondaryDescription.text}</Text>
                          </Flex>
                        )}
                      </div>
                    );
                  })}
              </Flex>
            </StyledFlexContainer>
          </Spacer>
        </div>
      }
    />
  );
};

export default ReviewSecurityDepositMultiPolicyConfirmationModal;
